// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","homeValue":"SuccessMessage_homeValue__15zrx","headline":"SuccessMessage_headline__4cKZF"};